import { setDoc, collection, doc, addDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../../firebase";
import HelperForMetaData from "../../../../helpers/HelperForMetaData";
// import { db } from "../../firebase";
// import HelperForMetaData from "../../helpers/HelperForMetaData";
// import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const UpdateDealController = async (
  id,
  dealData,
  transactionData,
  visitData,type
) => {
  console.log("start ", transactionData, visitData);
  try {
    /** Extracting transactions */
    const transactions = transactionData;


    const dealsDocument = await doc(db, "deals", id);

    if(type === "dealData"){
    /** Update Deals */
    dealData = { ...dealData, bid: getLocalStorageItem("bid") };
    await setDoc(dealsDocument, dealData);
    }
    else if(type === "transactionData"){
      if (transactionData.length) {
        /** Add Transactions */
        const transactionsCollection = await collection(
          dealsDocument,
          "transactions"
        );
        for (let index = 0; index < transactions.length; index++) {
          console.log("Landbook App: transaction : ", transactions[index]);
  
          if (transactions[index].hasOwnProperty("id")) {
            let transactionsDocument = await doc(
              dealsDocument,
              "transactions",
              transactions[index].id
            );
            await setDoc(
              transactionsDocument,
              HelperForMetaData(transactions[index], true)
            );
          } else {
            await addDoc(
              transactionsCollection,
              HelperForMetaData(transactions[index])
            );
          }
        }
      }
    }
    else if(type === "visitData"){
    if (visitData.length) {
      let visitsCollection = await collection(db, "visits");
      /** Add visits */
      for (let index = 0; index < visitData.length; index++) {
        console.log("Landbook App: transaction : ", visitData[index]);

        if (visitData[index].hasOwnProperty("id")) {
          let obj = {
            ...HelperForMetaData(visitData[index], true),
            dealId: id,
            agentId: dealData.agent.id,
            propertyId: dealData.property.id,
            bid: getLocalStorageItem("bid")

          }
          let visitsDocument = await doc(
            db,
            "visits",
            visitData[index].id
          );

          await setDoc(
            visitsDocument,
            obj 
          );
        } else {
          let obj = {
            ...HelperForMetaData(visitData[index]),
            dealId: id,
            agentId: dealData.agent.id,

            propertyId: dealData.property.id,
            bid: getLocalStorageItem("bid")

          }
          await addDoc(visitsCollection, obj);
        }
      }
    }}
    console.log("Deal added");
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default UpdateDealController;
